module.exports = __webpack_public_path__ + "img/process-arrow-img.9dedf34b.png";